import moment from 'moment';
import React from 'react';

import { withDocumentTitle } from '../../generic/DocumentTitle';
import Titled from '../../layout/Titled';
import add from '../../REST/add';
import api from '../../REST/api';
import { INTERNAL_DATE_FORMAT } from '../../utils/constants';
import { tapFlashSuccess } from '../../utils/flash';
import AgreementForm from '../AgreementForm';

const today = moment();

const AddAgreement = add({
  default: {
    name: '',
    accountId: 0,
    ownerId: 0,
    brandIds: [],
    salesUnit: '',
    salesTeam: '',
    startDate: today.format(INTERNAL_DATE_FORMAT),
    endDate: today.add(1, 'month').format(INTERNAL_DATE_FORMAT),
    budget: 0,
    businessModel: '',
    negotiatedBy: '',
    notes: '',
    type: '',
    quarterlyBudgets: [],
    mediaManagedBudgetShare: 0,
    mediaSelfServiceBudgetShare: 0,
    creativeBudgetShare: 0,
    ciBudgetShare: 0,
    otherBudgetShare: 0,
  },
  update: (props, model) =>
    api
      .addAgreement({
        data: model,
      })
      .then(tapFlashSuccess('Agreement created')),
  form: props => (
    <Titled title="Create Agreement">
      <AgreementForm newModel {...props} />
    </Titled>
  ),
  redirectTo: '/agreements/:id/show',
});

export default withDocumentTitle('Create Agreement')(AddAgreement);
